import {
  ScmIntegrationsApi,
  scmIntegrationsApiRef,
  ScmAuth,
} from '@backstage/integration-react';
import {
  AnyApiFactory,
  alertApiRef,
  configApiRef,
  createApiFactory,
} from '@backstage/core-plugin-api';
import { toastApiRef } from '@backstage/frontend-plugin-api';

export const apis: AnyApiFactory[] = [
  createApiFactory({
    api: scmIntegrationsApiRef,
    deps: { configApi: configApiRef },
    factory: ({ configApi }) => ScmIntegrationsApi.fromConfig(configApi),
  }),
  ScmAuth.createDefaultApiFactory(),
  // NotificationsSideBarItem uses toastApiRef (core.toast) from the new frontend-plugin-api.
  // app-defaults does not register it, so we bridge it to the existing alertApiRef
  // that AlertDisplay already handles visually.
  createApiFactory({
    api: toastApiRef,
    deps: { alertApi: alertApiRef },
    factory: ({ alertApi }) => ({
      post(toast) {
        const severity =
          toast.status === 'danger'
            ? 'error'
            : toast.status === 'neutral'
              ? undefined
              : (toast.status as 'success' | 'info' | 'warning' | undefined);
        alertApi.post({
          message: String(toast.title),
          severity,
          display: toast.timeout !== undefined ? 'transient' : 'permanent',
        });
        return { close: () => {} };
      },
    }),
  }),
];
